import React from "react";
import Tooltip from "@mui/material/Tooltip";

const RichTooltip = ({ title, children, sx = {}, ...props }) => (
  <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{title}</span>} sx={sx} {...props}>
    {children}
  </Tooltip>
);

export default RichTooltip;
